export function fetchLeadSession({ productId }: { productId: string }) {
  return fetch(`/api/lead-session/session?productId=${encodeURIComponent(productId)}`, {
    credentials: "same-origin",
  });
}

export function requestLeadSessionCode({
  productId,
  channel,
  email,
  phoneNumber,
}: {
  productId: string;
  channel: "email" | "phone";
  email?: string;
  phoneNumber?: string;
}) {
  return fetch("/api/lead-session/request-code", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify(
      channel === "phone"
        ? { productId, channel: "phone" as const, phoneNumber }
        : { productId, channel: "email" as const, email },
    ),
  });
}

export function verifyLeadSessionCode({
  productId,
  sessionId,
  code,
}: {
  productId: string;
  sessionId: string;
  code: string;
}) {
  return fetch("/api/lead-session/verify-code", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ productId, sessionId, code }),
  });
}

export function logoutLeadSession() {
  return fetch("/api/lead-session/logout", {
    method: "POST",
    credentials: "same-origin",
  });
}
